import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import Spinner from 'web/components/Spinner'
import AlertModal from 'web/components/AlertModal';
import { Modal, ModalBody } from 'reactstrap';
import { RequestTenderModalWrapper, RequestTenderModalContentWrapper, SelectWrapper } from "../myOrderStyled";
import CloseIcon from "web/assets/images/CloseIcon.png";
import DatePickerIcon from 'web/assets/svg/DatePickerIcon';
import TimerIcon from 'web/assets/svg/TimerIcon'
import DropDown from "web/components/DropDown";
import { fetchPickupRequestTenderDataApi, requestTendorApiCall } from "redux/actions/requestOrderPtplus";

function RequestTender(props) {
    const token = localStorage.getItem("token")
    const dispatch = useDispatch();
    let history = useHistory();
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
    const [comment, setComment] = useState('')
    const [selectedVendor, setSelectedVendor] = useState()
    const [vendorsList, setVendorsList] = useState([])
    const [alertModal, setAlertModal] = useState(false)
    const [alertModalContent, setAlertModalContent] = useState('')
    const [alertModalType, setAlertModalType] = useState()
    const [pageData, setPageData] = useState()

    useEffect(() => {
        let selectedItemRefNo = localStorage.getItem('requestTenderSelectedItemId')
        localStorage.removeItem('requestTenderSelectedItemId')
        fetchPageData(selectedItemRefNo)
    }, [])

    const fetchPageData = async (selectedItemRefNo) => {
        let response = await dispatch(fetchPickupRequestTenderDataApi(selectedItemRefNo, token));
        if (response.data?.success) {
            setPageData(response.data?.data)
            let vendorsList = response.data?.data?.vendorDetails?.map(data => {
                return ({
                    label: data.vendorLocationName,
                    value: data.vendorLocationId
                })
            })
            if (vendorsList && vendorsList?.length > 0) setVendorsList(vendorsList)
            else {
                setAlertModalType('closeModal')
                setAlertModalContent('No vendors available')
                setAlertModal(!alertModal)
            }
        } else {
            setAlertModalType('closeModal')
            if (response?.data?.error?.message === "Invalid Token" || response?.data?.error?.message === 'Request failed with status code 401') {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setAlertModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again in some time.')
                setAlertModal(!alertModal)
            }
        }
    }

    const requestTenderFunction = async () => {
        if (!selectedVendor) {
            setAlertModalContent('Please select a vendor')
            setAlertModal(true)
        } else {
            let data = {
                authId: localStorage.getItem('authId'),
                orderRefNumber: pageData?.orderRefNumber,
                vendorLocationId: selectedVendor,
                comment: comment
            }
            let response
            response = await dispatch(requestTendorApiCall(data, token))
            if (response?.data?.success) {
                setAlertModalType('requestTendorSuccess')
                setAlertModalContent(response?.data?.data?.msg)
                setAlertModal(!alertModal)
            } else {
                if (response?.data?.error?.message === 'Invalid Token') {
                    history.push('./sign-in')
                } else {
                    setAlertModalContent(response?.data?.data?.message || response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.')
                    setAlertModal(!alertModal)
                }
            }
        }
    }

    return (
        <RequestTenderModalWrapper>
            {(pageData && vendorsList?.length > 0) &&
                <Modal isOpen={true} centered={true} size={'lg'} className="request-tender-modal">
                    <RequestTenderModalContentWrapper>
                        <ModalBody>
                            {loaderVisible && <Spinner />}
                            <div className="outer-wrapper">
                                <div className="header">
                                    <h4>Create Tender</h4>
                                    <img src={CloseIcon} alt="close-icon" onClick={() => props.closeModal()} />
                                </div>
                                <div className="details-wrapper">
                                    <h4>Requested Pickup Details</h4>
                                    <div className='first-row' style={{ justifyContent: 'flex-start', gap: '48px' }}>
                                        <div>
                                            <h6>Ref. No.</h6>
                                            <p>{pageData?.orderRefNumber}</p>
                                        </div>
                                        <div>
                                            <h6>Customer Name</h6>
                                            <p>{pageData?.companyName}</p>
                                        </div>
                                    </div>
                                    <div className='first-row'>
                                        <div>
                                            <h6>Pickup Location</h6>
                                            <p style={{ marginBottom: '0px' }}>{pageData?.pickupLocation}</p>
                                        </div>
                                    </div>
                                    <div className='first-row'>
                                        <div>
                                            <h6>Estimated Qty.</h6>
                                            <p>{pageData?.quantity}</p>
                                        </div>
                                        <div>
                                            <h6>Requested Date</h6>
                                            <div className="date-picker-style">
                                                <DatePickerIcon />
                                                <p>{moment(pageData?.pickupDate).format('MM/DD/YYYY')}</p>
                                            </div>
                                        </div>
                                        <div className="app-timer-style">
                                            <h6>Requested Window</h6>
                                            <p style={{ margin: '0px', marginTop: '6px' }}><TimerIcon /> {pageData?.pickupStartTime} <span>To</span> <TimerIcon /> {pageData?.pickupEndTime}</p>
                                        </div>
                                        <div>
                                            <h6>Equipment</h6>
                                            <p>{pageData.loadingRequirement === 'DROP_TRAILER' ? 'Drop Trailer' : pageData.loadingRequirement === 'LIVE_LOAD' ? 'Live Load' : 'NA'}</p>
                                        </div>
                                    </div>
                                    <p className="buyer-comment"><h6>Customer Load Comments:</h6>{pageData?.comments}</p>
                                    <div className='second-row'>
                                        <div>
                                            <h6>Select Vendor</h6>
                                            <SelectWrapper>
                                                <DropDown
                                                    name="vendorList"
                                                    data={vendorsList}
                                                    searchDropDown={selectedVendor}
                                                    searchable={true}
                                                    placeholder='Vendor Name'
                                                    onChangeHandler={(data) => setSelectedVendor(data.value)}
                                                />
                                            </SelectWrapper>
                                        </div>
                                    </div>
                                    <div className='third-row'>
                                        <h6>External Load Comments to Supplier</h6>
                                        <textarea
                                            className="text-area"
                                            value={comment}
                                            onChange={(e) => (e.target.value.length <= 200 && setComment(e.target.value))}
                                        />
                                    </div>
                                    <div className="button-wrapper">
                                        <button onClick={requestTenderFunction}>Send Tender</button>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                    </RequestTenderModalContentWrapper>
                </Modal>
            }

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                content={alertModalContent}
                alertType='success'
                callBackAlert={() => {
                    if (alertModalType === 'closeModal') props.closeModal()
                    else if (alertModalType === 'requestTendorSuccess') {
                        props.closeModal()
                        props.requestTendorSuccessCallBack()
                    }
                }}
            />
        </RequestTenderModalWrapper>
    );
}

export default RequestTender;
